import { useMemo } from 'react';
import { useWorkspacesWithQueues } from '../../../queues/hooks/useWorkspacesWithQueues';

export const useQueueAndWorkspaceName = ({
  queueUrl,
}: {
  queueUrl: string | undefined;
}) => {
  const { workspacesWithQueues, isLoading } = useWorkspacesWithQueues({
    enableQueries: queueUrl !== undefined,
  });

  return useMemo(
    () =>
      workspacesWithQueues?.reduce<
        | {
            workspaceName: string;
            queueName: string;
            isLoading: boolean;
          }
        | undefined
      >((acc, workspace) => {
        if (acc) {
          return acc;
        }

        const queue = workspace.queues.find(({ url }) => url === queueUrl);

        return queue
          ? {
              workspaceName: workspace.name,
              queueName: queue.name,
              isLoading,
            }
          : acc;
      }, undefined) ?? {
        workspaceName: undefined,
        queueName: undefined,
        isLoading: false,
      },
    [workspacesWithQueues, isLoading, queueUrl]
  );
};
